import React from 'react'
import SocialPostComment from './SocialPostComment';
import { Comment } from 'types/social-account';
import "./SocialPostComments.scss"


interface SocialPostCommentsProps {
    comments: Comment[],
    loading: boolean,
    onReply: (comment: Comment) => void,
    onDelete: (comment: Comment, reset?: () => void) => void,
    onReplyPrivately: (comment: Comment) => void,
    deleting?: string[]
}

const SocialPostComments: React.FC<SocialPostCommentsProps> = ({ comments, loading, onReply, onDelete, onReplyPrivately, deleting = [] }) => {

    return (
        <div className="comments-list">
            {
                (loading) ? <div className='d-flex align-items-center justify-content-center py-5'><div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div></div> : (
                    <>
                        {comments.map((comment) => (
                            <SocialPostComment key={comment.id} onDelete={onDelete} onReply={onReply} onReplyPrivately={onReplyPrivately} comment={comment} />
                        ))}
                        {
                            (comments.length === 0) &&
                            <div className='d-flex align-items-center justify-content-center py-5'>
                                <span>No comments yet!</span>
                            </div>
                        }
                    </>
                )
            }
        </div>
    )
}

export default SocialPostComments
